__turbopack_context__.v({
  "cardBox": "demo-module__BdAxsG__cardBox",
  "container": "demo-module__BdAxsG__container",
  "correct": "demo-module__BdAxsG__correct",
  "cross": "demo-module__BdAxsG__cross",
  "explanation": "demo-module__BdAxsG__explanation",
  "header": "demo-module__BdAxsG__header",
  "header3": "demo-module__BdAxsG__header3",
  "label": "demo-module__BdAxsG__label",
  "nextBtn": "demo-module__BdAxsG__nextBtn",
  "normalbutton1": "demo-module__BdAxsG__normalbutton1",
  "optionCircle": "demo-module__BdAxsG__optionCircle",
  "optionsGrid": "demo-module__BdAxsG__optionsGrid",
  "payBox": "demo-module__BdAxsG__payBox",
  "payBtn": "demo-module__BdAxsG__payBtn",
  "payText": "demo-module__BdAxsG__payText",
  "restartBtn": "demo-module__BdAxsG__restartBtn",
  "resultCard": "demo-module__BdAxsG__resultCard",
  "scoreBox": "demo-module__BdAxsG__scoreBox",
  "text": "demo-module__BdAxsG__text",
  "tick": "demo-module__BdAxsG__tick",
  "title": "demo-module__BdAxsG__title",
  "wrong": "demo-module__BdAxsG__wrong",
});
